<template>
  <el-table
    v-loading="isLoading"
    :data="errors"
    size="small"
    stripe
  >
    <el-table-column
      fixed
      label="Date"
      prop="err_datetime"
      width="200px"
    />
    <el-table-column
      label="Message"
      prop="err_verbose"
    />
  </el-table>
</template>
<script>
import Filter, { IS } from '@/plugins/sdk/Filter'

export default {
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      errors: [],
      isLoading: true,
      isFullscreen: false
    }
  },
  created () {
    this.loadErrors()
  },
  methods: {
    loadErrors () {
      this.$sdk.error_log.list(builder => {
        builder.filters = [
          new Filter('err_type', IS, '24'),
          new Filter('err_link_pk', IS, this.invoice.reference)
        ]
      }).then(res => {
        this.errors = res
        this.isLoading = false
      })
    }
  }
}
</script>
